export default "__VITE_ASSET__IrjUG$P8__"